import React, { FC } from 'react';

export interface IReportWraperProps {}

export const withReportWraper =
  (Component: FC<IReportWraperProps>) => (props: IReportWraperProps) => {
    return (
      <div className='withReportWraper'>
        {/* <div className="TabLinks">
                <NavLink to={Routes.transactionList.path} >
                    <Icon.Exchange />

                    Transactions
                </NavLink>

                <NavLink to={Routes.withdraw.path} >
                    <Icon.KYC />

                    Withdraw Progress
                </NavLink>
            </div> */}

        <Component {...props} />
      </div>
    );
  };
